import { datadogRum } from '@datadog/browser-rum';
import type { EventProperties } from '@helios/frontend-core';
import { trackEvent } from '@helios/frontend-core';

const plaidEvents = {
  flowStarted: { amplitude: 'plaid bank verification flow started', datadog: 'plaid_flow_started' },
  linkOpened: { amplitude: 'plaid link opened', datadog: 'plaid_link_opened' },
  linkTransitionView: { amplitude: 'plaid link transition view', datadog: 'plaid_link_transition_view' },
  linkError: { amplitude: null, datadog: 'plaid_link_error' },
  linkEvent: { amplitude: null, datadog: 'plaid_link_event' },
  linkLeftOpen: { amplitude: 'plaid link left open', datadog: 'plaid_link_left_open' },
  linkExitedNoMethod: { amplitude: 'plaid link exited no method', datadog: 'plaid_exit_no_method' },
  linkExitedAbandoned: { amplitude: 'plaid link exited abandoned', datadog: 'plaid_exit_abandoned' },
  linkInterrupted: { amplitude: 'plaid link interrupted', datadog: 'plaid_link_interrupted' },
  linkRecoveredSuccess: { amplitude: 'plaid link recovered success', datadog: 'plaid_link_recovered_success' },
  linkRecoveredExit: { amplitude: 'plaid link recovered exit', datadog: 'plaid_link_recovered_exit' },
  linkResumed: { amplitude: 'plaid link resumed', datadog: 'plaid_link_resumed' },
  linkBackNavBlocked: { amplitude: null, datadog: 'plaid_link_back_nav_blocked' },
  verifyAccountSuccess: { amplitude: 'plaid verify account success', datadog: 'plaid_verified' },
  verifyAccountError: { amplitude: 'plaid verify account error', datadog: 'plaid_verify_error' },
  verifyNoAccount: { amplitude: null, datadog: 'plaid_verify_no_account' },
  connectionError: { amplitude: null, datadog: 'plaid_connection_error' },
} as const;

type PlaidEventKey = keyof typeof plaidEvents;

export function trackPlaidEvent(
  key: PlaidEventKey,
  props: EventProperties = {},
  datadogExtra: Record<string, unknown> = {},
): void {
  const event = plaidEvents[key];
  if (event.amplitude !== null) trackEvent(event.amplitude, props);
  datadogRum.addAction(event.datadog, { ...props, ...datadogExtra });
}
